module.exports = __webpack_public_path__ + "img/no_ai_material.8bde7bd7.png";